import { createReducer, on } from '@ngrx/store';
import {
  changeUserAction,
  resetUserStateAction,
  changeSessionAction,
  changeAuthSessionAction
} from './user.actions';

import { initialUserState } from './user.state';

export const userReducer = createReducer(
  initialUserState,
  on(resetUserStateAction, (state, params) => ({ ...initialUserState })),
  on(changeUserAction, (state, params) => ({...state, user: params.user })),
  on(changeSessionAction, (state, params) => ({...state, session: params.session})),
  on(changeAuthSessionAction, (state, params) => ({...state, authSession: params.authSession}))
  
);
